import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_alert, { class: "mt-2 mb-4" }),
            _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-title-underline" }, "カレンダー", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, [
              _createElementVNode("iframe", {
                class: "calendar",
                frameborder: "0",
                scrolling: "no",
                src: "https://calendar.google.com/calendar/embed?src=90i599606q9qionq2ljqm1pl7k%40group.calendar.google.com&ctz=Asia%2FTokyo"
              })
            ], -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}